import { PicklistDataItem } from "../../../../Engine/src/Engine/Core/Picklists/PicklistTypes";

import { taxRebate1152026 } from "./Data/TaxRebate1152026";

export const allFakePicklists: Array<[string, PicklistDataItem[]]> = [["463", taxRebate1152026]];
